import { useCallback, useRef } from 'react'

export const useDuplicateEvents = (
  eventName: string,
): {
  isSent: (key: string) => boolean
  markSent: (key: string) => void
  isEventCalled: (key: string) => boolean
  reset: () => void
} => {
  const sentRef = useRef(new Set())

  const makeKey = useCallback(
    (key: string) => `${eventName}::${key}`,
    [eventName],
  )

  const isSent = useCallback(
    (key: string) => sentRef.current.has(makeKey(key)),
    [makeKey],
  )

  const markSent = useCallback(
    (key: string) => {
      sentRef.current.add(makeKey(key))
    },
    [makeKey],
  )

  const isEventCalled = useCallback(
    (key: string) => {
      const full = makeKey(key)
      if (sentRef.current.has(full)) {
        return false
      }
      sentRef.current.add(full)
      return true
    },
    [makeKey],
  )

  const reset = useCallback(() => {
    sentRef.current.clear()
  }, [])

  return { isSent, markSent, isEventCalled, reset }
}
